import React from 'react';

interface IProps {
  children: React.ReactNode;
}

const TabContainer: React.FC<IProps> = ({ children }) => {
  return <div className='tab-container'>{children}</div>;
};

export default TabContainer;
